import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import detector from 'i18next-browser-languagedetector';
import Log from '@helpers/Log';
import es from './es';
import ptBr from './pt-br';


const resources = {
  es,
  pt: ptBr,
  'pt-BR': ptBr,
};
const languages = Object.keys(resources);
const namespaces = Object.keys(ptBr);

const i18nStorageKey = 'i18nextLng';


i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .use(detector)
  .init({
    detection: {
      order: ['querystring', 'cookie', 'localStorage', 'htmlTag'],
      lookupQuerystring: 'lng',
      lookupCookie: 'i18n',
      lookupLocalStorage: i18nStorageKey,
    },
    supportedLngs: languages,
    ns: namespaces,
    // lng: 'es',
    fallbackLng: 'pt-BR', // use if detected lng is not available
    defaultNS: 'global',
    fallbackNS: 'global',
    saveMissing: true, // send not translated keys to endpoint
    keySeparator: false, // we do not use keys in form messages.welcome
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    react: {
      bindI18n: 'languageChanged',
      bindI18nStore: '',
      transEmptyNodeValue: '',
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i'],
      useSuspense: false,
    },
  });

Object.keys(resources).forEach(lng => {
  const resource = resources[lng];
  Object.keys(resource).forEach(ns => i18n.addResources(lng, ns, resource[ns]));
});

window.missingTranslations = {};

i18n.on('languageChanged', lng => {
  Log.debug(`[LNG] Language changed to ${lng}`);
  const l = String(lng).toLowerCase();

  if (l === 'pt-br' || l === 'pt') {
    window.isBR = true;
  } else {
    window.isBR = false;
  }
});

i18n.on('missingKey', (lngs: string[], namespace: string, key: string, res: string) => {
  if (window.missingTranslations[namespace]) {
    window.missingTranslations[namespace][key] = res;
  } else {
    window.missingTranslations[namespace] = {};
    window.missingTranslations[namespace][key] = res;
  }
});

window.i18n = i18n;
global.i18n = i18n;

// The country before login (sent on sign-up, and the language until the user's own country is known) comes
// from the language i18next started with, the same one it saves: 'pt-BR' (its fallback) gives 'BR'
const setCountryCode = () => {
  window.countryCode = i18n.language ? i18n.language.replace(/\w+-/, '') : 'BR';
};

let initialized = false;
i18n.on('initialized', () => {
  initialized = true;
});

export default () => new Promise(resolve => {
  const done = () => {
    setCountryCode();
    resolve();
  };
  if (initialized) {
    done();
  } else {
    i18n.on('initialized', done);
  }
});

